import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  closeDrawer: {
    id: 'X/RZRd',
    defaultMessage: 'Close',
    description: 'Aria label for the close button in the HTML editor drawer',
  },
  loadEditorError: {
    id: 'hwRtT1',
    defaultMessage: 'An error occurred while loading the editor. If this problem persists, please contact support.',
    description: 'Error message shown when the editor fails to load',
  },
  retryButton: {
    id: 'bnSOAa',
    defaultMessage: 'Try Again',
    description: 'Button text to retry loading the editor',
  },
  syntaxError: {
    id: '+lmG8y',
    defaultMessage: '<b>Syntax not valid:</b> Line {lineNumber}',
    description: 'Error message shown when HTML syntax validation fails, indicating the line number with the error',
  },
  malformedLiquidError: {
    defaultMessage: '<b>Unclosed template expression:</b> {detail} on Line {lineNumber}',
    id: 'vdtXu9',
    description: 'Error message shown when a Liquid template expression opener (for example {{ or {%) is missing its matching closer',
  },
  printUnsupported: {
    id: 'ByTbDs',
    defaultMessage: '<b>Not supported for printing:</b> {detail} on Line {lineNumber}',
    description: 'Error message shown when an HTML element or attribute is not supported for PDF printing',
  },
  invalidField: {
    id: 'moVIGe',
    defaultMessage: '<b>Unknown field:</b> {detail} on Line {lineNumber}',
    description: 'Error shown when a template field expression references a field that does not exist',
  },
  imageValidationError: {
    id: 'yx2DLt',
    defaultMessage: '<b>Image validation error:</b> {detail}{lineNumber, plural, =0 {} one { on Line #} other { on Line #}}',
    description: 'Error shown when an image fails validation (size, type, URL, or host)',
  },
  imageFileSizeTooLarge: {
    id: 'b9wmVc',
    defaultMessage: 'Image file size exceeds 1MB limit: {detail}',
    description: 'Error message when image file size is too large',
  },
  imageIsNotAllowed: {
    id: 'L5s746',
    defaultMessage: 'Image is not allowed: {detail}',
    description: 'Error message when image is not allowed (unsupported type, invalid URL, or blocked host)',
  },
  undoButton: {
    id: 'LL+ebG',
    defaultMessage: 'Undo',
    description: 'Aria label for the undo button in the HTML editor',
  },
  redoButton: {
    id: 'OiAYgF',
    defaultMessage: 'Redo',
    description: 'Aria label for the redo button in the HTML editor',
  },
});
